import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

declare const Weglot: any;

@Injectable({
  providedIn: 'root'
})
export class WeglotService {
  initializeWeglot() {
    if (typeof Weglot !== 'undefined') {
      Weglot.initialize({
        api_key: environment.keys.weglot,
        original_language: 'en',
        hide_languages: [],
        auto_switch: false,
        whitelist: [
          {
            value: '.weglot-allowed'
          }
        ],
        exclude_blocks: ['.no-translate', '.notranslate']
      });
    }
  }

  removeWeglot() {
    const weglotDropdown = document.querySelector('.weglot-container');
    if (weglotDropdown) {
      weglotDropdown.remove();
    }
  }
}
